import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa";
import { MdFavorite } from "react-icons/md";
import { BsTrash } from "react-icons/bs";
import { DisplayDiscussionForMiniScreenContext } from "../../contexts/DisplayDiscussionForMiniScreenContext";
// import { CritereFiltreContext } from "../../contexts/CriteresFiltreContext";
import { AuthContext } from "../../contexts/AuthContext";
import { WorkspaceContext } from "../../contexts/WorkspaceContext";
import { addOrRemoveToFavorite } from "../../services/conversations";
import { IoHeartDislike } from "react-icons/io5";
import { socket } from "../../services/socket";
import { supprimerTousEnInbox } from "../../services/sendMessageInbox";
import { supprimerTousEnGroupe } from "../../services/sendMessageGroupe";
import { cacheMessages } from "../../services/messageCache";
import { includesId } from "../../services/idUtils";

export default function OptionsList({
  display,
  interlocuteur,
  setDisplayDiscussionForMiniScreen,
  roomId,
  addFavoriteBy,
  isGroupe,
  groupe,
}) {
  const { setDestinataire, setCrew, setActiveRoomIdInbox, setActiveRoomIdCrew } = useContext(DisplayDiscussionForMiniScreenContext);
  const { user } = useContext(AuthContext);
  const { currentWorkspace } = useContext(WorkspaceContext);
  const workspaceId = currentWorkspace?._id;
  const navigate = useNavigate();
  const [added, setAdded] = useState(includesId(addFavoriteBy, user.userId));

  useEffect(() => {
    const handleAdded = ({ roomId: rid, added }) => {
      if (rid === roomId) setAdded(added);
    };
    const handleRemoved = ({ roomId: rid, added }) => {
      if (rid === roomId) setAdded(added);
    };
    socket.on("channel_added_with_success", handleAdded);
    socket.on("channel_removed_with_success", handleRemoved);

    return () => {
      socket.off("channel_added_with_success", handleAdded);
      socket.off("channel_removed_with_success", handleRemoved);
    };
  }, [roomId]);
  return (
    <>
      <div
        className={`dropdown-menu dropdown-menu-end ${
          display
            ? "show affiche-dropdown-menu-options-list-detail-message"
            : ""
        }`}
      >
        <ul className="tyn-list-links">
          <li>
            <button
              onClick={() => {
                setDisplayDiscussionForMiniScreen(true);
                if (isGroupe) {
                  navigate(`/groupes/${groupe.roomId}`);
                } else {
                  setDestinataire(interlocuteur);
                  navigate(`/contact/${interlocuteur.username}`);
                }
              }}
            >
              <FaUser />
              <span>{isGroupe ? "Détails du groupe" : "Voir le Profil"}</span>
            </button>
          </li>
          {/* <hr /> */}
          <li>
            <button
              onClick={() => {
                addOrRemoveToFavorite(user.userId, roomId, workspaceId);
              }}
            >
              {!added ? (
                <>
                  <MdFavorite />
                  <span>Ajouter aux favoris</span>
                </>
              ) : (
                <>
                  <IoHeartDislike />
                  <span>Retirer des favoris</span>
                </>
              )}
            </button>
          </li>
          {/* <hr /> */}
          <li>
            <button
              onClick={() => {
                if (isGroupe) {
                  supprimerTousEnGroupe(
                    roomId,
                    user.userId,
                    interlocuteur,
                    groupe.membres,
                    workspaceId
                  );
                  cacheMessages(roomId, []);
                  setCrew(null);
                  setActiveRoomIdCrew("");
                } else {
                  supprimerTousEnInbox(
                    roomId,
                    user.userId,
                    interlocuteur.userId,
                    workspaceId
                  );
                  cacheMessages(roomId, []);
                  setDestinataire(null);
                  setActiveRoomIdInbox("");
                }
                setDisplayDiscussionForMiniScreen(false);
              }}
              data-bs-toggle="modal"
            >
              <BsTrash />
              <span>Effacer</span>
            </button>
          </li>
        </ul>
      </div>
    </>
  );
}
